// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const glameow: PokeData = {
  "id": 431,
  "name": "glameow",
  "height": 5,
  "weight": 39,
  "base_experience": 62,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "tackle",
    "double-edge",
    "growl",
    "hypnosis",
    "fury-swipes",
    "slash",
    "feint-attack",
    "charm",
    "attract",
    "fake-out",
    "taunt",
    "assist",
    "aerial-ace",
    "sucker-punch",
    "night-slash",
    "nasty-plot",
    "captivate",
    "hone-claws",
    "retaliate",
    "play-rough"
  ],
  "moves": [
    "scratch",
    "tackle",
    "growl",
    "aerial-ace",
    "night-slash",
    "play-rough",
    "splash",
    "tri-attack",
    "leer",
    "body-slam",
    "refresh",
    "headbutt",
    "purification"
  ],
  "evolution_chain": {
    "id": 221,
    "item": null,
    "species": [
      {
        "name": "glameow",
        "order": 456,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "purugly",
        "order": 457,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 431,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 44.25,
    "speed": 85,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
